import * as React from "react";
import { Colors } from "../../../../design-tokens/colors";
import styles from "./case-distribution.styles";

const CASE_DISTRIBUTION = [
  {
    percent: 4,
    displayPercent: "2-4%",
    label: "Deaths",
    color: Colors.Red,
  },
  {
    percent: 10,
    displayPercent: "10%",
    label: "ICU care",
    color: Colors.Orange,
  },
  {
    percent: 20,
    displayPercent: "20%",
    label: "Hospitalisation",
    color: Colors.Purple,
  },
  {
    percent: 66,
    displayPercent: "68%",
    label: "Mild or asymptomatic cases",
    color: Colors.LightBlue,
  },
];

const CaseDistribution: React.FC = () => {
  return (
    <div css={styles.root}>
      <div css={styles.barContainer}>
        {CASE_DISTRIBUTION.map((c) => (
          <div
            key={c.label}
            css={{ flexBasis: `${c.percent}%`, backgroundColor: c.color }}
          />
        ))}
      </div>
      <div css={styles.labelContainer}>
        {CASE_DISTRIBUTION.map((c) => (
          <div key={`l-${c.label}`}>
            <div css={styles.label}>{c.label}</div>
            <div css={styles.percent}>
              <span css={[styles.indicator, { backgroundColor: c.color }]} />
              {c.displayPercent}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseDistribution;
